import PropTypes from 'prop-types';

const defaultProps = {
  htmlId: null,
  className: null,
  disabled: false,
};

const propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password', 'tel']).isRequired,
  htmlId: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function Input({
  type,
  name,
  htmlId,
  disabled,
  ...props
}) {
  const htmlIdFinal = htmlId || name;

  return (
    <input
      id={htmlIdFinal}
      type={type}
      name={name}
      disabled={disabled}
      {...props}
    />
  );
}

Input.defaultProps = defaultProps;
Input.propTypes = propTypes;

export {
  defaultProps as InputDefaultProps,
  propTypes as InputPropTypes,
};
